import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import NearbyErrorIcon from '@mui/icons-material/NearbyError';
import { getAllProjects } from 'src/services/projectDetailService';
import moment from 'moment';
const Versions = ({
  selectedProject,
  setSelectedProject,
  summary,
  getSummary
}) => {
  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    paddingRight: 15,
    fontSize: '11px',
    height: '1.75rem'
  };

  const [allProjects, setAllProjects] = useState<any>([]);

  const getAllProjectGroups = async () => {
    const result = await getAllProjects();
    setAllProjects(result.data);
  };

  useEffect(() => {
    getAllProjectGroups();
  }, []);

  const clear = () => {
    setSelectedProject(allProjects[0]?.name);
  };

  useEffect(() => {
    clear();
  }, [allProjects, setSelectedProject]);

  return (
    <Card style={{ padding: '1rem' }}>
      <Grid
        item
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2 }}
        >
          <Typography
            sx={{
              fontSize: '19px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            {selectedProject}
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Select
              className="select-text"
              size="small"
              style={selectStyle}
              inputProps={{ 'aria-label': 'Without label' }}
              displayEmpty
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.target.value)}
            >
              {allProjects?.length > 0 &&
                allProjects.map((element) => {
                  return (
                    <MenuItem value={element.name}>{element.name}</MenuItem>
                  );
                })}
            </Select>
            <Button
              size="small"
              sx={{
                width: '50%',
                ml: 3,
                fontSize: '11px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              style={{ height: '1.75rem' }}
              variant="contained"
              type="button"
              onClick={() => getSummary(selectedProject)}
            >
              Generate
            </Button>
            <Button
              size="small"
              sx={{
                ml: 3,
                width: '50%',
                background: '#F5F7FF',
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              style={{ height: '1.75rem' }}
              onClick={() => clear()}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#0069E4' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Initial Planned Hours
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {summary?.plannedHours}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#FFC107' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Revised Planned Hours
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {summary?.revisedPlannedHours}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#00B26A' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Actual Hours Speed
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {summary?.actualRemainingEffort}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#ED1C24' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Remaining Hours
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {summary?.remainingEffort}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#EA3BCE' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Pre-sale Date
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {moment(summary?.preSalesStartDate).format('Do MMMM YYYY')}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#0069E4' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Actual Start Date
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {moment(summary?.actualStartDate).format('Do MMMM YYYY')}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#FFC107' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Planned End Date
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {moment(summary?.plannedEndDate).format('Do MMMM YYYY')}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#00B26A' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Project Price
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {summary?.price}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            borderBottom: '1px solid #E1E1E1',
            alignItems: 'center'
          }}
          sx={{ pb: 2, pt: 2 }}
        >
          <Box
            style={{
              background: `rgba(186, 206, 229, 0.5)`,
              lineHeight: '0',
              padding: '0.6rem',
              marginRight: '1rem',
              borderRadius: '5px'
            }}
          >
            <NearbyErrorIcon style={{ fontSize: '1rem', color: '#ED1C24' }} />
          </Box>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#5B5B5B'
            }}
          >
            Client and Country
          </Typography>
          <Grid item style={{ display: 'flex', marginLeft: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#5B5B5B'
              }}
            >
              {`${summary?.client} ${summary?.country}`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default Versions;
